import { Atom } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({ theme, displayState }) => css`
    i {
        font-size: 12px;
        color: ${displayState.selected && theme?.colour?.secondary};
      }

    @media only screen and (min-width: 768px) {
      i {
          font-size: 14px;
        }
    }
  `}
`;

export default Atom({ type: 'label', dataType: 'object', template })